<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <v-card-title>
          <span class="text-h5">Data Testimoni</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid" class="pl-4 pr-4">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="currentData.judul"
                        label="Judul"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.judulRules"
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.konten"
                        label="Konten"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.kontenRules"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="currentData.judul_en"
                        label="Judul Inggris"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.judulRules"
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.konten_en"
                        label="Konten Inggris"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.kontenRules"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-combobox
                    v-model="currentData.selectedHide"
                    label="Publish"
                    clearable
                    dense
                    outlined
                    :items="currentData.items_hide"
                    item-text="name"
                    item-value="code"
                  ></v-combobox>
                  <v-file-input
                    v-model="filefoto"
                    label="Foto Thumbnail (Cover)"
                    accept="image/*"
                    prepend-icon="mdi-image"
                    clearable
                    dense
                    outlined
                    @change="loadImage"
                  >
                  </v-file-input>
                  <v-row v-if="filefoto" class="my-5">
                    <v-col cols="12" sm="6" md="5">
                      <v-responsive :aspect-ratio="16 / 9">
                        <v-img
                          :key="currentData.fotoKey"
                          :src="currentData.FotoUrl"
                          contain
                        ></v-img>
                      </v-responsive>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div>
                <CardGallery />
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="router.back()">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useRouter } from "../../utils/utils.js";
import TestimoniService from "../../services/web_content/TestimoniService";
import CommonService from "../../services/CommonService";
import CardGallery from "../../components/CardGallery.vue";

const form = ref(null);
const isValid = ref(false);

// Composables
const router = useRouter();

// State
const breadcrumbs = [
  {
    text: "Testimoni",
    disabled: false,
    href: "/webcontent/testimoni",
  },
  {
    text: "Tambah Testimoni",
    disabled: true,
    href: "breadcrumbs_dashboard",
  },
];

const filefoto = ref(null);
const currentData = reactive({
  judul: "",
  konten: null,
  judul_en: "",
  konten_en: null,
  selectedKategori: "",
  selectedHide: "",
  foto_url: "",
  fotoKey: 0,
  FotoUrl: "",
  items_hide: [
    { code: 1, name: "Publish" },
    { code: 2, name: "Hide" },
  ],
  judulRules: [(v) => !!v || "Judul harus diisi"],
  kontenRules: [(v) => !!v || "Konten harus diisi"],
});

// Methods
const loadImage = (file) => {
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      currentData.FotoUrl = e.target.result;
      currentData.fotoKey++;
    };
    reader.readAsDataURL(file);
  } else {
    currentData.FotoUrl = "";
    currentData.foto_url = null;
  }
};

const doSave = async () => {
  try {
    await form.value.validate();

    if (!isValid.value) {
      window.scrollTo(0, 0);
      return;
    }

    await TestimoniService.create(currentData, filefoto.value);
    CommonService.showSuccessToast("Tambah testimoni berhasil");
    router.push("/webcontent/testimoni");
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Tambah testimoni gagal. Coba lagi");
  }
};
</script>
